var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('a',{attrs:{"href":'/Payment/'+_vm.row.GroupCode,"target":"_blank"}},[_vm._v(_vm._s(_vm.row.GroupCode))])}
var staticRenderFns = []

export { render, staticRenderFns }